import { Button, Group, Text } from "@mantine/core";
import { getCTAButtons } from "../config/navigation";
import classes from "./AuthButtons.module.css";
import { useNavigation } from "@/hooks/useNavigation";

export interface AuthButtonsProps {
  className?: string;
  variant?: "default" | "compact";
}

/**
 * Auth buttons for sign in and registration.
 * 
 * Note: Uses consistent "filled" variant to avoid hydration mismatch.
 * Color-scheme-dependent variants (gradient vs filled) cause SSR/client
 * mismatches because color scheme is determined client-side.
 */
export default function AuthButtons({
  className,
  variant = "default",
}: AuthButtonsProps) {
  const { handleLoginClick, handleRegisterClick } = useNavigation();
  const ctaButtons = getCTAButtons();

  if (variant === "compact") {
    return (
      <Group gap="sm" wrap="nowrap" className={className}>
        <Text
          component="a"
          href={ctaButtons.login.link}
          onClick={handleLoginClick}
          className={classes.link}
        >
          {ctaButtons.login.label}
        </Text>
        <Button
          variant="filled"
          size="sm"
          onClick={handleRegisterClick}
          className={classes.button}
        >
          {ctaButtons.register.label}
        </Button>
      </Group>
    );
  }

  return (
    <Group gap="sm" wrap="nowrap" className={className}>
      <Text
        component="a"
        href={ctaButtons.login.link}
        onClick={handleLoginClick}
        className={classes.link}
      >
        {ctaButtons.login.label}
      </Text>
      <Button
        variant="filled"
        size="sm"
        onClick={handleRegisterClick}
        className={classes.button}
      >
        {"Get Started - It's Free"}
      </Button>
    </Group>
  );
}
